<template>

  <v-app height="100%" style="background-color: #9bddeb">
    <div style="padding-top:25px; padding-left:15px; padding-right:15px;">
      <v-layout
        justify-space-between
      >
        <div>
        <v-layout justify-start align-start>
          <v-card flat  width="50%"
            color= "#9bddeb"
            @click="setDisplay('open')"
          >

            <img  v-if="display != 'open'"
              src="https://www.vacationinbox.com/img/vacation_inbox_logo_on_transparent-01.png"
              width="200px"
            >
          </v-card> 
        </v-layout>
        </div>
        <div>
        <v-layout v-if="width > 600" justify-end align-center>


          <div style="width:125px; padding-right:10px">
            <v-btn
              outlined
              @click="joinVI"
            >
              Join Now
            </v-btn>
          </div>
          <div v-if="getMobileOperatingSystem() == 'notMobile'">
            <v-btn
              outlined
              @click="openVI"
            >
              Login
            </v-btn>
          </div>
        </v-layout>
        <v-layout v-else justify-end align-center>
          <div style="padding-right:4px">
            <v-btn
              outlined
              x-small
              @click="joinVI"
            >
              Join Now
            </v-btn>
          </div>
          <div v-if="getMobileOperatingSystem() == 'notMobile'">
            <v-btn
              outlined
              x-small
              @click="openVI"
            >
              Login
            </v-btn>
          </div>
        </v-layout>
        </div>
      </v-layout>
    </div>
    <div v-if="display == 'open'" style="margin-left: auto; margin-right: auto;">
      <img
        src="https://www.vacationinbox.com/img/vacation_inbox_logo_on_white-01.png"
        width="100%"
      >
    </div>
    <div v-if="display == 'open'  && width > 600" style="padding-top:10px">
      <v-layout justify-space-around align-center>
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised color="#3953a3" @click="setDisplay('Plan.')" >
            <v-layout justify-center>
            <img 
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-open" style="color:white">Plan.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Plan.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-open" style="color:white">Plan.</span>
            </v-layout>
          </v-card>
        </v-hover>
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised color="#3953a3" @click="setDisplay('Collaborate.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-open">Collaborate.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Collaborate.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-open">Collaborate.</span>
            </v-layout>
          </v-card>
        </v-hover>
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised color="#3953a3" @click="setDisplay('Go.')" >
            <v-layout justify-center>  
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-open" style="color:white">Go.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-large"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-open" style="color:white">Go.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </v-layout>
    </div>
    <div v-if="display == 'open'  && width <= 600" style="padding-top:5px;">
      <v-layout justify-center> 
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised width="150" color="#3953a3" @click="setDisplay('Plan.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Plan.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised width="150" color="#4ebdef" @click="setDisplay('Plan.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Plan.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </v-layout>
      <div  style="padding-top: 15px;"> </div>
      <v-layout justify-center>
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised width="150" color="#3953a3" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised width="150" color="#4ebdef" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </v-layout>
      <div  style="padding-top: 15px;"> </div>
      <v-layout justify-center>
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover" raised width="150" color="#3953a3" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised width="150" color="#4ebdef" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </v-layout>
    </div>


    <div v-if="display != 'open'" style="padding-top:20px"></div>
    <div v-if="display != 'open'">
      <v-layout justify-start align-center>
        <div>
          <span class="display-title font-weight-medium" style="color:#3953a3">{{ display }}</span>
        </div>
      </v-layout>
    </div>




    <v-layout  v-if="display != 'open'" justify-left>
    <div v-if="width > 600" >
      <div style="margin-left: auto; margin-right: auto; text-align: center; ">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Plan.'" raised color="#3953a3" @click="setDisplay('Plan.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Plan.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Plan.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Plan.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
      <div style="padding-top:20px"></div>
      <div  style="margin-left: auto; margin-right: auto; text-align: center;">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Collaborate.'" raised color="#3953a3" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
     <div style="padding-top:20px"></div>
      <div  style="margin-left: auto; margin-right: auto; text-align: center;">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Go.'" raised color="#3953a3" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
    </div>



    <div v-if="display == 'Plan.' && width <= 600 && height > 400" style="width:100%; margin-left: auto; margin-right: auto; text-align: center;">
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/plan.png"
            class="splash"
          >
        </div>
        <div>
          <span style="color:#3953a3" class="display-splash font-weight-medium">
             Consolidate Your Vacation Research
          </span>
        </div>
    </div>
    <div v-if="display == 'Collaborate.' && width <= 600 && height > 400" style="width:100%; margin-left: auto; margin-right: auto; text-align: center;">
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/collaborate.png"
            class="splash"
          >
        </div>
        <div>
          <span style="color:#3953a3" class="display-splash font-weight-medium">
             Easily Share Your Ideas and Itineraries With Others
          </span>
        </div>
    </div>
    <div v-if="display == 'Go.' && width <= 600 && height > 400" style="width:100%; margin-left: auto; margin-right: auto; text-align: center;">
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/go.png"
            class="splash"
          >
        </div>
        <div>
          <span style="color:#3953a3" class="display-splash font-weight-medium">
             Travel Better Organized Than Ever Before
          </span>
        </div>
    </div>
    <div v-if="display == 'Plan.' && width > 600" style="width:100%">
      <v-layout justify-space-around align-start>
        <div style="padding-left:1px"></div>
        <div>
          <div><span style="color:#3953a3" class="display-splash-large font-weight-medium">
             Consolidate Your Vacation Research
          </span></div>
          <ul>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Notes
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Bookmarks
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             To Do Lists
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Emails
            </li>
          </ul>
        </div>
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/plan.png"
            class="splash"
          >
        </div>
      </v-layout>
    </div>
    <div v-if="display == 'Collaborate.' && width > 600" style="width:100%">
      <v-layout justify-space-around align-start>
        <div style="padding-left:1px"></div>
        <div>
          <div><span style="color:#3953a3" class="display-splash-large font-weight-medium">
             Coordinate With Others
          </span></div>
          <ul>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Ideas
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Share Reservations
            </li>
           <li style="color:#3953a3" class="display-splash font-weight-medium">
             Polls
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Emails
            </li>
           <li style="color:#3953a3" class="display-splash font-weight-medium">
             Chat
            </li>
          </ul>
        </div>
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/collaborate.png"
            class="splash"
          >
        </div>
      </v-layout>
    </div>
    <div v-if="display == 'Go.' && width > 600" style="width:100%">
      <v-layout justify-space-around align-start>
        <div style="padding-left:1px"></div>
        <div>
          <div><span style="color:#3953a3" class="display-splash-large font-weight-medium">
             Organized Travel
          </span></div>
          <ul>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Avaliable On iPhone, Android And Web
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Easy Access To Reservations
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Open Locations In Maps
            </li>
           <li style="color:#3953a3" class="display-splash font-weight-medium">
             Expenses
            </li>
            <li style="color:#3953a3" class="display-splash font-weight-medium">
             Emails
            </li>
          </ul>
        </div>
        <div>
          <img
            src="https://www.vacationinbox.com/img/site/go.png"
            class="splash"
          >
        </div>
      </v-layout>
    </div>
    </v-layout>


    <div v-if="display != 'open' && width <= 600 && height > 400"  style="position: fixed; bottom: 50px; width:100%">


    <v-layout  justify-center>
      <div style="margin-left: auto; margin-right: auto; text-align: center;">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Plan.'" raised color="#3953a3" @click="setDisplay('Plan.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Plan.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Plan.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/plan_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Plan.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
      <div style="padding-left:20px;"></div>
      <div  style="margin-left: auto; margin-right: auto; text-align: center;">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Collaborate.'" raised color="#3953a3" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Collaborate.')">
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/site/collaborate_logo.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span  style="color:white;" class="display-small">Collaborate.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
     <div style="padding-left:20px"></div>
      <div  style="margin-left: auto; margin-right: auto; text-align: center;">
        <v-hover v-slot:default="{ hover }">
          <v-card v-if="hover || display == 'Go.'" raised color="#3953a3" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
          <v-card v-else raised color="#4ebdef" @click="setDisplay('Go.')" >
            <v-layout justify-center>
            <img
              src="https://www.vacationinbox.com/img/vacation_inbox_avatar_white.png"
              class="circle-logo-small"
            >
            </v-layout>
            <v-layout justify-center>
            <span class="display-small" style="color:white">Go.</span>
            </v-layout>
          </v-card>
        </v-hover>
      </div>
    </v-layout>

     </div>





    <div v-if="height > 400"  style="position: fixed; bottom: 0; width: 100%;">
      <v-layout justify-end>
        <v-btn 
          text
          @click="openFAQ"
        >
          <span style="color:#3953a3" class="overline">FAQ</span>
        </v-btn>
        <v-btn
          text
          @click="openPrivacy"
        >
          <span style="color:#3953a3" class="overline">Privacy</span>
        </v-btn>
        <v-btn
          text
          @click="openTermsOfUse"
        >
          <span style="color:#3953a3" class="overline">Legal</span>
        </v-btn>
          <div  v-if="width > 600 || getMobileOperatingSystem() == 'iOS'" style="width:125px; padding-right:140px;">
            <a href="https://www.vacationinbox.com/ios">
              <img src="https://www.vacationinbox.com/img/apple-store.webp" width="125">
             </a>
           </div>
           <div  v-if="width > 600 ||  getMobileOperatingSystem() == 'Android'"  style="width:125px; padding-right:140px">
             <a href="https://www.vacationinbox.com/aos">
               <img src="https://www.vacationinbox.com/img/google-play.webp" width="125">
             </a>
          </div>
      </v-layout>
    </div>
    <div v-else style="width: 100%; padding-top:20px">
      <v-layout justify-end>
        <v-btn
          text
          @click="openFAQ"
        >
          <span style="color:#3953a3" class="overline">FAQ</span>
        </v-btn>
        <v-btn
          text
          @click="openPrivacy"
        >
          <span style="color:#3953a3" class="overline">Privacy</span>
        </v-btn>
        <v-btn
          text
          @click="openTermsOfUse"
        >
          <span style="color:#3953a3" class="overline">Legal</span>
        </v-btn>
      </v-layout>
    </div>





  </v-app>
</template>
<script>

export default {
  name: 'Site',
  data: function() {
    return {
      display: 'open',
      colorPlan: 'white',
      colorCollaborate: 'white',
      colorGo: 'white',
      height: 900, 
      width: 900,
      removeWarning: '',
    }
  },
  mounted() {
    this.$nextTick(function() {
       window.addEventListener('resize', this.setHeightWidth);
        //Init
         this.setHeightWidth();
      });
  },
  methods: {
    setHeightWidth(event) {
      this.removeWarning = event;
      this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.height =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    },
    setDisplay(display) {
      this.display = display;
      this.colorPlan = 'white';
      this.colorCollaborate = 'white';
      this.colorGo = 'white';
      if (display == 'Plan.') {
        this.colorPlan = 'blue lighten-5';
      } else if (display == 'Collaborate.') {
        this.colorCollaborate = 'blue lighten-5';
      } else if (display == 'Go.') {
        this.colorGo = 'blue lighten-5';
      }
    },
    joinVI() {
      window.location = "https://www.vacationinbox.com/register/";
    },
    openVI() {
      window.location = "https://www.vacationinbox.com/vi/app/";
    },
    openFAQ() {
      window.location = "https://www.vacationinbox.com/faq/";
    },
    openPrivacy() {
      window.location = "https://www.vacationinbox.com/PrivacyPolicy.html";
    },
    openTermsOfUse() {
      window.location = "https://www.vacationinbox.com/TermsOfUse.html";
    },
    getMobileOperatingSystem() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) {
          return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      return "notMobile";
    },

   },
   beforeDestroy() {
       window.removeEventListener('resize', this.getWindowHeight);
   }
}
</script>
